import { render } from "./list-choose-tag.vue?vue&type=template&id=3f17cb8c&scoped=true&ts=true"
import script from "./list-choose-tag.vue?vue&type=script&lang=ts"
export * from "./list-choose-tag.vue?vue&type=script&lang=ts"

import "./list-choose-tag.vue?vue&type=style&index=0&id=3f17cb8c&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f17cb8c"]])

export default __exports__